import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { fetchPartyWrapped } from '../api/client.js';
import { partyWrappedQueryKey } from '../api/queryKeys.js';

import type { PartySlug, PartyWrapped } from '@mixwire/contracts';

// A finished party's recap is settled history, so it never needs refetching.
export const usePartyWrapped = (slug: PartySlug): UseQueryResult<PartyWrapped> =>
  useQuery({
    queryKey: partyWrappedQueryKey(slug),
    queryFn: async () => fetchPartyWrapped(slug),
    staleTime: Infinity,
  });
